export default function BlurredPrice() {
  return (
    <span className="blur-[.3em] font-bold">$100,999</span>
  );
}
